interface AetherMarkProps {
  size?: number;
  className?: string;
}

/** Terrapi Aether glyph — a layered shield/stack denoting encrypted blocks. */
export function AetherMark({ size = 22, className }: AetherMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M12 2.5 20 6v6.5c0 4.5-3.3 7.6-8 9-4.7-1.4-8-4.5-8-9V6l8-3.5Z"
        stroke="var(--accent)"
        strokeWidth="1.6"
        strokeLinejoin="round"
        fill="color-mix(in oklch, var(--accent), transparent 88%)"
      />
      <path d="M12 8.5v7" stroke="var(--accent)" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M8.5 12h7" stroke="var(--accent)" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
